import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/matematik';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-296" data-mp="pujbplccaf8u">
      <div className="mx-auto max-w-6xl" data-id="element-297" data-mp="b5wkomdcnz1s">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-298" data-mp="b4v7ab8v30gw">
          Hvad indeholder <em className="whitespace-nowrap text-rose-600" style={{
          hyphens: 'manual'
        }} data-id="element-299" data-mp="269vcyxwajp3">BILLEDKLAR™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-300" data-mp="75w9rbpgm5zh">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-301" data-mp="3od86u2knfza5">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-302" data-mp="3tbjgac7187ru">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Bind" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-303" data-mp="3cw0kc9aodmkx">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-rose-600/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-304" data-mp="3ht0rknj9gvdm" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-305" data-mp="2aenk38v6317a">{item.number}</span>
                <span className="mt-1 font-serif text-2xl leading-none" data-id="element-306" data-mp="26edhm66l2sx6">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-307" data-mp="9dh9z9ejmnmb">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-308" data-mp="j2hd9502w56b">
          <AnimatePresence mode="wait" initial={false} data-id="element-309" data-mp="o1kl0x7g0phz">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-310" data-mp="3mk9aoywzhhbw">
              <div className="lg:col-span-5" data-id="element-311" data-mp="599mffjtndpo">
                <p className="text-sm font-semibold text-rose-600" data-id="element-312" data-mp="1bqmz5v2vc07q">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-313" data-mp="1gsvvn1ey9kel">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-314" data-mp="2w9qrevasoruq">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-315" data-mp="2wc39d8gjz27s">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-316" data-mp="2mjxftuankcqh">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-317" data-mp="2mj4j7m5er3m2">Indhold</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-318" data-mp="2hl2wmr8rwm5u">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-319" data-mp="2di6c2uzoafz9">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose-600" strokeWidth={2.5} aria-hidden="true" data-id="element-320" data-mp="28l7icdjx8b1l" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-321" data-mp="6rqd1gj9jma0">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-322" data-mp="1uhtpcmdpc76">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-323" data-mp="2zlypwrngmvvi">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-324" data-mp="2lo0cppkvl5hl">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-325" data-mp="2lpuyf63z11mq">
              Hvad gør BILLEDKLAR™ anderledes?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-326" data-mp="2bw4dgb71z9bs">
              Hele skoleåret i billedkunst – organiseret og klar til brug.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-327" data-mp="22yaip4oxsnqq">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-328" data-mp="1sz330auqch0g">
                  <Icon className="h-6 w-6 text-rose-600" strokeWidth={1.75} aria-hidden="true" data-id="element-329" data-mp="1t04l2za5y3ro" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-330" data-mp="1xwl8tsdgag48">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-331" data-mp="1ecml2e7jpxbl">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}